import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { LabelingSpecDetailComponent } from '../../../../process/process-plans/labeling-spec-detail/labeling-spec-detail.component'
import { LabelingSpec } from '../../../../process/process-plans/process-plan'
import {
  BatchItemLabelProvisioning,
  defaultLabelingProvisionOptions,
  WorkCenter,
} from '../../work-center'
import { MatIcon } from '@angular/material/icon'
import { MatTooltip } from '@angular/material/tooltip'

@Component({
  selector: 'app-work-center-labeling',
  templateUrl: './work-center-labeling.component.html',
  styleUrls: ['./work-center-labeling.component.scss'],
  imports: [
    AsyncPipe,
    FormsModule,
    MatSlideToggle,
    LabelingSpecDetailComponent,
    ElderTranslatePipe,
    MatIcon,
    MatTooltip,
  ],
})
export class WorkCenterLabelingComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _workCenter$: BehaviorSubject<WorkCenter> = new BehaviorSubject<WorkCenter>(null)

  public readonly labelingSpec$: BehaviorSubject<LabelingSpec> = new BehaviorSubject<LabelingSpec>(
    null
  )

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Getter / Setters                                                        *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set workCenter(workCenter: WorkCenter) {
    if (workCenter && !workCenter.labeling.labelProvisioningOptions) {
      workCenter.labeling.labelProvisioningOptions = defaultLabelingProvisionOptions() // TODO: move?
    }
    this._workCenter$.next(workCenter)
    if (workCenter && workCenter?.labeling?.labelingSpec) {
      this.labelingSpec$.next(workCenter.labeling.labelingSpec)
    }
  }

  public get workCenter(): WorkCenter {
    return this._workCenter$.getValue()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  handleOverrideToggleChange(event: MatSlideToggleChange): void {
    let spec: LabelingSpec = null

    if (event.checked) {
      spec = new LabelingSpec()
    }

    this.workCenter.labeling.labelingSpec = spec
    this.labelingSpec$.next(spec)
  }

  isProvisioningEnabled(mode: BatchItemLabelProvisioning): boolean {
    return mode === BatchItemLabelProvisioning.CLOUD_FILE
  }

  handleProvisioningToggleChange($event: MatSlideToggleChange): void {
    const mode = $event.checked
      ? BatchItemLabelProvisioning.CLOUD_FILE
      : BatchItemLabelProvisioning.PRINT
    this.workCenter.labeling.batchItemLabelProvisioning = mode
  }
}
